// extracted by mini-css-extract-plugin
export default {"select":"k0XgD","title":"hCFwS"};